import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';

@Injectable({
  providedIn: 'root'
})
export class OrderService extends BaseService {

  constructor(protected http: HttpClient) {
    super();
   }

   public createPaymentPayU(order) {
     return this.http.post<RequestResponse>(this.getUrl('createPayment'), order);
   }

   public myOrders(data) {
    return this.http.post<RequestResponse>(this.getUrl('myOrders'), data);
  }

  public addPrepaidCode(code) {
    return this.http.post<RequestResponse>(this.getUrl('addPrepaidCode'), code);
  }

  public getPrepaidCodes() {
    return this.http.get<RequestResponse>(this.getUrl('getPrepaidCodes'));
  }

  public prepaidByCode(code) {
    return this.http.post<RequestResponse>(this.getUrl('prepaidByCode'), code);
  }

  public getPrepaidAmount() {
    return this.http.get<RequestResponse>(this.getUrl('getPrepaidAmount'));
  }

  public checkNoteOrderedPayed(noteId) {
    return this.http.post<RequestResponse>(this.getUrl('checkNoteOrderedPayed'), {id: noteId});
  }

  public prepaidPay(data) {
    return this.http.post<RequestResponse>(this.setUrl('orders/prepaid'), data);
  }
}
